export default "__VITE_ASSET__DsmVBbbT__"